import * as React from 'react'

import { cn } from '@/lib/utils'

export interface ColorPickerProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value?: string
  onChange?: (value: string) => void
}

const ColorPicker = React.forwardRef<HTMLInputElement, ColorPickerProps>(
  ({ className, value, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value)
    }

    const normalizedValue = value?.startsWith('#') ? value : `#${value || '000000'}`

    return (
      <div className="inline-flex items-center gap-2">
        <input
          type="color"
          ref={ref}
          value={normalizedValue}
          onChange={handleChange}
          className={cn(
            'border-input hover:border-primary focus-visible:ring-ring h-10 w-14 cursor-pointer rounded-md border bg-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          {...props}
        />
      </div>
    )
  }
)
ColorPicker.displayName = 'ColorPicker'

export { ColorPicker }
